export const NO_DATA_AVAILABLE = 'No Data Available'

export function getNoDataGraphic(isDark = false) {
  return [
    {
      type: 'text',
      left: 'center',
      top: 'middle',
      z: 100,
      style: {
        text: NO_DATA_AVAILABLE,
        fill: isDark ? '#9aa0a6' : '#8b949e',
        fontSize: 14,
        fontWeight: 500,
      },
    },
  ]
}

export function seriesHasData(series) {
  if (!Array.isArray(series) || series.length === 0) {
    return false
  }
  return series.some((s) => Array.isArray(s?.data) && s.data.length > 0)
}

/**
 * Apply a universal empty-state overlay to ECharts options.
 * When empty: show "No Data Available" and hide axes/tooltip/legend.
 */
export function applyEmptyChartState(options, hasData, isDark = false) {
  if (!options) {
    return options
  }

  options.graphic = hasData ? [] : getNoDataGraphic(isDark)

  if (options.tooltip) {
    options.tooltip.show = !!hasData
  }
  if (options.legend) {
    options.legend.show = !!hasData
  }

  const setAxisShow = (axis) => {
    if (!axis) return
    if (Array.isArray(axis)) {
      axis.forEach((a) => {
        if (a) a.show = !!hasData
      })
    } else {
      axis.show = !!hasData
    }
  }

  setAxisShow(options.xAxis)
  setAxisShow(options.yAxis)

  return options
}
